import { CareerPathwayLevel } from "@/components/career-pathway-level"
import AppLayout from "@/layouts/AppLayout"

export default function CareerPathwayJunior() {
  return (
    <CareerPathwayLevel
      config={{
        name: "Junior",
        level: 1,
        emoji: "\ud83d\udc23",
        color: "green",
        description:
          "Desarrollador sin experiencia previa con clientes USA. Est\u00e1 todo el tiempo aprendiendo, pero tambi\u00e9n siendo capaz de contribuir en tareas de complejidad baja o media.",
        sections: [
          {
            title: "Comunicaci\u00f3n",
            color: "blue",
            icon: "\ud83d\udcac",
            content:
              "Se espera que puedan comunicarse con el cliente, participando en las reuniones grupales y dem\u00e1s instancias que sean parte de la rutina. Depender\u00e1 del resto del equipo para clarificar requerimientos, coordinar el trabajo, fijar expectativas. Tendr\u00e1 apoyo para cuidar sus interacciones, recibiendo feedback al instante de c\u00f3mo se viene relacionando.",
          },
          {
            title: "Contribuci\u00f3n",
            color: "purple",
            icon: "\ud83d\udc65",
            content:
              "Contribuye a un nivel individual, ya que su inter\u00e9s primordial es el de lograr adaptarse al contexto laboral en el cual se encuentra. Su foco de contribuci\u00f3n est\u00e1 en transformarse en un miembro valioso de su equipo de trabajo.",
          },
        ],
        deepDive: [
          "Tiene conocimientos b\u00e1sicos de programaci\u00f3n y desarrollo web, que le permiten empezar a colaborar en un proyecto, aunque tenga nula experiencia laboral previa con clientes USA.",
          "Dependen totalmente del apoyo de compa\u00f1eros que lo van guiando, mentoreando, aconsejando, y elimin\u00e1ndole las trabas t\u00e9cnicas que hagan falta.",
          "Las tareas en las que puede trabajar son de las m\u00e1s sencillas (features b\u00e1sicas, stories que se estiman para hacer en plazos cortos).",
          "El nivel de autonom\u00eda es bajo. Requieren de supervisi\u00f3n y de gu\u00eda pr\u00e1cticamente a diario.",
          "Est\u00e1n en constante aprendizaje de las tecnolog\u00edas.",
        ],
        prev: { name: "Volver a Career Pathway", url: "/growth/career-pathway" },
        next: { name: "Siguiente: Advanced", url: "/growth/career-pathway/advanced" },
      }}
    />
  )
}

CareerPathwayJunior.layout = (page: React.ReactNode) => <AppLayout>{page}</AppLayout>
